import AdminApi from '../../services/api';
import swal from 'sweetalert2';
import session from '../../services/session';
import CONFIG_COMPANY from '../../services/myConfig';
import Loc from '../../services/localization';

const AdminApiService = new AdminApi();
const LocService = new Loc();

export default {
  data() {
    return {
      locale: LocService,
      role: '',
      loading: false,
      fromDate: null,
      toDate: null,
      filter: '',
      items: [],
      selectedBucketKey: null
    };
  },
  computed: {
    groupedBuckets() {
      const map = {};
      (this.items || []).forEach((item) => {
        const key = this.getBucketKey(item.inventoryTimestamp);
        if (!key) return;
        if (!map[key]) {
          map[key] = {
            key: key,
            label: this.formatBucketLabel(key),
            count: 0
          };
        }
        map[key].count += 1;
      });
      return Object.keys(map)
        .sort((a, b) => this.$moment(b, 'YYYY-MM-DD HH:mm').valueOf() - this.$moment(a, 'YYYY-MM-DD HH:mm').valueOf())
        .map((key) => map[key]);
    },
    filteredItems() {
      const query = (this.filter || '').toLowerCase().trim();
      const byBucket = (this.items || []).filter((item) => {
        if (!this.selectedBucketKey) return true;
        return this.getBucketKey(item.inventoryTimestamp) === this.selectedBucketKey;
      });
      if (!query) return byBucket;
      return byBucket.filter((item) => {
        const name = (item.name || '').toLowerCase();
        const createdBy = (item.createdBy || '').toLowerCase();
        return name.indexOf(query) !== -1 || createdBy.indexOf(query) !== -1;
      });
    }
  },
  methods: {
    load: load,
    openAddNewInventory: openAddNewInventory,
    formatDateTime: formatDateTime,
    keymonitor: keymonitor,
    normalizeImage: normalizeImage,
    getDisplayName: getDisplayName,
    getBucketKey: getBucketKey,
    formatBucketLabel: formatBucketLabel,
    selectBucket: selectBucket,
    isBucketActive: isBucketActive
  },
  beforeMount() {
    if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
      this.$router.push(CONFIG_COMPANY.HOME);
      return;
    }
    this.role = session.getRole();
    this.toDate = this.$moment(new Date()).format('YYYY-MM-DD');
    this.fromDate = this.$moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD');
    this.load();
  },
  watch: {
    fromDate() {
      this.load();
    },
    toDate() {
      this.load();
    }
  }
};

function openAddNewInventory() {
  this.$router.push('/add-new-inventory');
}

function load() {
  if (!this.fromDate || !this.toDate) return;
  this.loading = true;

  const params = {
    from: this.$moment(this.fromDate).format('DD-MM-YYYY'),
    to: this.$moment(this.toDate).format('DD-MM-YYYY')
  };

  AdminApiService.getShopInventoryItems(params)
    .then((response) => {
      this.items = response.data || [];
      if (this.selectedBucketKey) {
        const exists = this.groupedBuckets.some((bucket) => bucket.key === this.selectedBucketKey);
        if (!exists) this.selectedBucketKey = null;
      }
      this.loading = false;
    })
    .catch((error) => {
      this.loading = false;
      swal(LocService.t('label_error'), (error && error.data && error.data.localized_error_message) || LocService.t('label_no_data'), 'error');
    });
}

function formatDateTime(value) {
  if (!value) return '-';
  return toMoment(this, value).format('DD-MM-YYYY HH:mm');
}

function keymonitor(event) {
  if (event.key === 'Enter') {
    this.load();
  }
}

function normalizeImage(item) {
  return item.imageUrl || '';
}

function getDisplayName(item) {
  if (session.getLocale() === LocService.getDefaultLanguage()) {
    return item.name || '';
  }
  if (item.enName != null && item.enName.length > 0) {
    return item.enName;
  }
  return item.name || '';
}

function getBucketKey(value) {
  if (!value) return null;
  const m = toMoment(this, value);
  if (!m.isValid()) return null;
  const roundedMinutes = Math.floor(m.minute() / 5) * 5;
  return m.clone().minute(roundedMinutes).second(0).millisecond(0).format('YYYY-MM-DD HH:mm');
}

function formatBucketLabel(key) {
  if (!key) return '';
  return this.$moment(key, 'YYYY-MM-DD HH:mm').format('DD-MM-YYYY HH:mm');
}

function selectBucket(key) {
  this.selectedBucketKey = key || null;
}

function isBucketActive(key) {
  if (!key && !this.selectedBucketKey) return true;
  return this.selectedBucketKey === key;
}

function toMoment(ctx, value) {
  const asNumber = Number(value);
  if (!isNaN(asNumber) && isFinite(asNumber)) {
    return ctx.$moment(asNumber * 1000);
  }
  return ctx.$moment(value);
}



// WEBPACK FOOTER //
// ./src/components/Inventory/InventoryHistory.js